import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Account } from 'src/app/_models/Account';

import { AccountService } from 'src/app/_services/http/account.service';
import { loginActionSuccess } from 'src/app/_store/AccountStore/account.store';
import { MainStoreState } from 'src/app/_store/mainStoreState';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  constructor(private accountService: AccountService, private store: Store<MainStoreState>) {}

  ngOnInit(): void {}

  login() {
    this.accountService.login().subscribe((response) => {
      if (response) {
        if (response.hasOwnProperty('redirectUrl')) {
          window.location.href = (response as any).redirectUrl;
        } else {
          this.store.dispatch(loginActionSuccess({ payload: response as Account }));
        }
      }
    });
  }
}
